import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

function NotFound() {
  return (
    <div className="min-h-screen bg-white dark:bg-black flex items-center justify-center px-4">
      <motion.div
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.2 }}
        className="text-center"
      >
        <p className="text-8xl font-bold text-black dark:text-white mb-4">404</p>
        <p className="text-lg text-gray-500 dark:text-gray-400 mb-8">This page doesn't exist.</p>
        <Link to="/" className="btn-modern inline-block">
          Go home
        </Link>
      </motion.div>
    </div>
  );
}

export default NotFound;
